import {PaiPointComponentsEnum} from "../../interface";
import {MainPageConfigInterface} from "../../interface/MainPage";
import {PaiPointButtonActionTypeEnum} from "../../interface/ComponentsInterface";

export const mainPageConfigDefault: MainPageConfigInterface = {
    headerConfig: {
        show: true,
        maxWidth: '100%',
        width: '100%',
        backgroundColor: '#FFFFFF',
        containerConfig: {
            justifyContent: 'space-between'
        },
        items: [
            {
                id: '0',
                type: PaiPointComponentsEnum.CONTAINER,
                containerConfig: {
                    justifyContent: 'space-between',
                    paddingLeft: '20px',
                    paddingRight: '20px'
                },
                items: [
                    {
                        id: '2345',
                        type: PaiPointComponentsEnum.LOGO,
                        imgUrl: '',
                        websiteName: '派点科技',
                        width: 'auto',
                        height: '100%',
                        fontSize: '20px',
                        fontWeight: '700',
                        link: '',
                        cursor: 'pointer',
                        containerConfig: {
                        }
                    },
                ]
            },
            {
                id: '1',
                type: PaiPointComponentsEnum.CONTAINER,
                containerConfig: {
                    paddingLeft: '20px',
                    paddingRight: '20px'
                },
                items: [
                    // {
                    //     id: '123',
                    //     type: PaiPointComponentsEnum.MENU,
                    //     backgroundColor: 'transparent',
                    //     activeColor: '#1677ff',
                    //     textColor: '#000000',
                    //     containerConfig: {},
                    //     linkMenu: [
                    //         {
                    //             label: '首页',
                    //             key: 'home',
                    //             icon: false,
                    //         },
                    //         {
                    //             label: '关于',
                    //             key: 'about',
                    //             icon: false,
                    //         }
                    //     ]
                    // },
                    // {
                    //     id: '345',
                    //     type: PaiPointComponentsEnum.BUTTON,
                    //     containerConfig: {
                    //         paddingLeft: '20px',
                    //         paddingRight: '0px',
                    //         alignItems: 'center',
                    //     },
                    //     itemConfig: {
                    //         loading: false,
                    //         label: '登录',
                    //         action: {
                    //             type: PaiPointButtonActionTypeEnum.NAVIGATE,
                    //             url: '/login'
                    //         }
                    //     }
                    // },
                ]
            },
        ],
    },
    pageConfig: {
        show: true,
        maxWidth: '100%',
        width: '100%',
        backgroundColor: '#FFFFFF',
        containerConfig: {
            height: 'auto'
        },
        items: [
            {
                id: 'foot-0',
                type: PaiPointComponentsEnum.TEXT,
                containerConfig: {
                    justifyContent: 'center',
                    alignItems: 'center',
                    flex: 'none',
                    width: '100%',
                    height: 'auto',
                    paddingTop: '30%'
                },
                items: [
                    {
                        textConfig: {
                            fontSize: '32px',
                            fontWeight: '700',
                            justifyContent: 'center',
                            height: 'auto',
                        },
                        text: '网站建设中，敬请期待！'
                    },
                ]
            },
        ]
    },
    footerConfig: {
        show: true,
        maxWidth: '100%',
        width: '100%',
        backgroundColor: '#FFFFFF',
        containerConfig: {
            justifyContent: 'center',
            backgroundColor: '#FFFFFF',
            paddingTop: '24px',
            paddingBottom: '24px',
            flex: 'none',
            alignItems: 'center'
        },
        items: [
            {
                id: 'foot-0',
                type: PaiPointComponentsEnum.TEXT,
                containerConfig: {
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flex: 'none'
                },
                items: [
                    {
                        textConfig: {},
                        text: '· 甘井子区派点软件信息技术服务中心 ·'
                    },
                ]
            },
            {
                id: 'foot-0',
                type: PaiPointComponentsEnum.BUTTON,
                containerConfig: {
                    justifyContent: 'space-between',
                    flex: 'none'
                },
                itemConfig: {
                    label: '辽ICP备2024033978号-1',
                    loading: false,
                    type: 'link',
                    action: {
                        type: PaiPointButtonActionTypeEnum.LINK,
                        url: 'https://beian.miit.gov.cn/',
                    }
                }
            }
        ]
    }
}